export default __webpack_public_path__ + "static/media/0011.1bd8aa74.svg";